import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { addIcons } from 'ionicons';
import { moon, sunny } from 'ionicons/icons';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss']
})
export class ThemeToggleComponent implements OnInit, OnDestroy {
  @Input() iconOnly = false;
  currentTheme: 'light' | 'dark';
  private detachListener?: () => void;

  constructor(private renderer: Renderer2) {
    addIcons({ moon, sunny });
    this.currentTheme = (localStorage.getItem('tubify-theme') as 'light' | 'dark') || 'light';
  }

  ngOnInit(): void {
    this.applyTheme(this.currentTheme, false);
    this.detachListener = this.renderer.listen(window, 'theme-changed', (event: any) => {
      if (event?.detail === 'light' || event?.detail === 'dark') {
        this.currentTheme = event.detail;
        this.applyTheme(this.currentTheme, false);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.detachListener) {
      this.detachListener();
    }
  }

  toggle(): void {
    this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    this.applyTheme(this.currentTheme, true);
  }

  private applyTheme(theme: 'light' | 'dark', broadcast: boolean): void {
    localStorage.setItem('tubify-theme', theme);
    this.renderer.setAttribute(document.documentElement, 'data-theme', theme);
    if (broadcast) {
      window.dispatchEvent(new CustomEvent('theme-changed', { detail: theme }));
    }
  }
}
